import { UnreachableError } from 'base/helpers';
import { CardStyle, CardStyleRadiusOption } from 'base/styleguide/model';
import {
  IconRadius0,
  IconRadius1,
  IconRadius2,
  IconRadius3,
} from 'base/ui/icons';
import { observable } from 'mobx';

export const CARD_STYLES = [
  CardStyle.Default,
  CardStyle.Outlined,
  CardStyle.Flat,
  CardStyle.Edgy,
];

export const getCardStyleLabel = (cardStyle: CardStyle) => {
  switch (cardStyle) {
    case CardStyle.Default:
      return 'Default';
    case CardStyle.Outlined:
      return 'Outlined';
    case CardStyle.Flat:
      return 'Flat';
    case CardStyle.Edgy:
      return 'Edgy';
    default:
      throw new UnreachableError(cardStyle);
  }
};

export const CARD_STYLE_RADIUS_OPTIONS = [
  CardStyleRadiusOption.Radius0,
  CardStyleRadiusOption.Radius1,
  CardStyleRadiusOption.Radius2,
  CardStyleRadiusOption.Radius3,
];

export const getCardStyleRadiusOptionIcon = (option: CardStyleRadiusOption) => {
  switch (option) {
    case CardStyleRadiusOption.Radius0:
      return IconRadius0;
    case CardStyleRadiusOption.Radius1:
      return IconRadius1;
    case CardStyleRadiusOption.Radius2:
      return IconRadius2;
    case CardStyleRadiusOption.Radius3:
      return IconRadius3;
    default:
      throw new UnreachableError(option);
  }
};

export const globalCardStyleOverrideStore = observable.box<CardStyle | null>(
  null,
);
